module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('span', {
    staticClass: "big1"
  }, [_vm._v("1"), _c('br'), _vm._v("The First and Finest")]), _c('br'), _vm._v("The Founders of Alpha Phi Alpha Fraternity"), _c('br'), _c('em', [_c('span', {
    staticClass: "normal"
  }, [_vm._v("Stefan Bradley")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("In creating a fraternity at a starkly white Ivy League university (Cornell), Alpha Phi Alpha’s founders (affectionately known as the Jewels) were part of a black intelligentsia that created opportunities for black people in the United States. Established in 1906 as the first incorporated collegiate fraternity created explicitly for African Americans, Alpha was the offspring of two important historical movements that contested Jim Crow in America: the Niagara movement and the “uplift” movement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Niagara movement was led by some of black America’s brightest minds. Men such as W. E. B. DuBois used their intellect to fight Jim Crow in all its ugly forms. In this way, the black intelligentsia was in the vanguard of the fight for total freedom. At the same time, black America’s middle and elite classes took steps to help downtrodden black people in what was known as the uplift movement. This was an extension of the “self-help” program that leaders such as Booker T. Washington had propagated. To advance the uplift movement, class-and race-aware black activists formed various service societies and social clubs in their campaign against racism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the wake of the uplift and Niagara movements, the Jewels created a fraternal bond among black men that has endured for more than 100 years. The seven Jewels of the fraternity were Henry Arthur Callis, Charles Henry Chapman, Eugene Kinckle Jones, George Biddle Kelley, Nathaniel Allison Murray, Robert Harold Ogle, and Vertner Woodson Tandy.")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("A Lineage Of Uplift")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("“First of all; servants of all; we shall transcend all.” That is the motto of Alpha Phi Alpha Fraternity Inc. As the first official fraternity for African American college men, Alpha focused on service to the community and displayed many of the "), _c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v("qualities of black America’s elite class in the early twentieth century. Whether the Jewels realized it or not, Alpha, by way of its founding and programs, transcended much of black and white America at the time. As such, early Alpha represented the uplift movement by way of the founders’ economic standing and social status and their politically charged push for racial equality—a lofty ideal at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At a time when most black Americans (and much of America in general) concentrated on tilling, planting, cultivating, and harvesting, some Americans looked beyond the fields to make a life for themselves. For those who could afford it, there was the possibility of higher education. This was a relatively new option for African Americans, as many institutions for the education of black people had been established shortly after the Civil War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the beginning of the twentieth century, though, a majority of black people still lived in the South and worked at jobs associated with agriculture. Some owned the land on which they worked, but many others sharecropped or tenant-farmed the land they cultivated. Sharecropping and tenant farming, by most modern accounts, were glorified versions of slavery for many black people."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn1",
      "id": "c1_fn1a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")])]), _vm._v(" Because their agreements often consisted of written contracts, white owners frequently cheated black sharecroppers. This was possible, in part, because so many African American laborers were unable to read."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn2",
      "id": "c1_fn2a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("2")])]), _vm._v(" In addition, there was little recourse for those black sharecroppers who caught landowners cheating on their contracts. Indeed, Jim Crow justice prevailed throughout the court system and in much of the rest of the nation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the twentieth century, black leaders attempted to assist the race in different ways. Booker T. Washington tried to improve the lot of black farmers by offering agricultural, mechanical, and industrial training at institutions such as Tuskegee. He advocated a plan that socially accommodated racism but encouraged black people to help themselves by becoming indispensable to southern economic progress in agriculture and the service industry. To many African Americans, a liberal arts education at a university seemed unattainable. With that in mind, Washington pushed a platform of economic self-help for blacks through thrift and ownership."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn3",
      "id": "c1_fn3a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("W. E. B. DuBois sought to provide different opportunities for African Americans. As a northerner born after slavery ended, DuBois had a different outlook from that of Washington. The first black person to earn a doctorate from the prestigious Harvard University, DuBois urged the best and brightest African American minds to pursue professional careers as doctors, lawyers, teachers, and the like."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn4",
      "id": "c1_fn4a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("4")])]), _vm._v(" He and Washington clashed in their approaches to social "), _c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v("and political freedom, but they agreed that, to advance, black people must uplift themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The idea of racial uplift took on different meanings in the early twentieth century. As historian Kevin Gaines explains in his work "), _c('em', [_vm._v("Uplifting the Race,")]), _vm._v(" to former slaves, uplift meant “transcendence of worldly oppression and misery.” The founders of Alpha Phi Alpha also saw transcendence as a crucial step for fraternity members. Gaines notes that, in search of this uplift, “African Americans have, with almost religious fervor, regarded education as the key to liberation.” Likewise, the education and advancement of black men was the basis for the initial interaction among the fraternity’s founders. Finally, Gaines’s analysis reveals an aspect of Alpha that has been underemphasized in the past. He suggests that “many black elites sought status, moral authority, and recognition of their humanity by distinguishing themselves, as bourgeois agents of civilization, from the presumably undeveloped black majority.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn5",
      "id": "c1_fn5a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("5")])]), _vm._v(" The founders of the fraternity attempted to prove that African Americans had a culturally relevant past and that they, as students at an elite university, represented the best of that legacy.")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("Welcome to Ithaca")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The Jewels of Alpha created the fraternity in the shadows of these movements. In 1905, while most black people headed to the fields, several black men attended one of the nation’s most esteemed institutions of higher education, Cornell University. Situated on a hill in Ithaca, New York, Cornell was one of several Ivy League universities that admitted African Americans at the time. Although it admitted black students, Cornell was, like the winters in Ithaca, cold for nonwhite learners. As a member of the Ivy League, Cornell’s curriculum was broad and featured rigorous courses of study in many areas, and the school administered entrance examinations for incoming students. The opportunity to matriculate at such an institution was rare for many Americans but even more so for African Americans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The initial intention of the Jewels was not to create a fraternity at Cornell but rather to fight the isolation of the black students. The university had graduated its first African Americans some sixteen years prior to the Jewels’ arrival on campus in 1905."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn6",
      "id": "c1_fn6a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("6")])]), _vm._v(" The Jewels were part of a small minority population on campus—they were seven of eleven African Americans who arrived that year."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn7",
      "id": "c1_fn7a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("7")])]), _vm._v(" In all, there were sixteen black males at the universtiy."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn8",
      "id": "c1_fn8a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("8")])]), _vm._v(" At least six African Americans from the previous year’s class had not returned. Indeed, the statistics "), _c('a', {
    attrs: {
      "id": "page22"
    }
  }), _vm._v("were bleak. The rigors of the academic programs, racial isolation, and finances were all threats to the survival of African American students at Cornell.")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("Scholastic Socialization")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("To confront these threats, several black students formed a social/study group for the sake of networking. An older student, C. C. Poindexter, helped facilitate the social mixers that the founders attended. Jewel Murray remembered the mixers fondly and explained that the meetings “provided … wholesome recreation and amusement.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn9",
      "id": "c1_fn9a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the time, black students did not live on campus, so they took up residence with the black citizens of Ithaca. It was in the homes of residents such as Edward Newton that the social/study group held its events. Although the black students may have been isolated on campus, they enjoyed the support of the larger African American community in town. According to Jewel Kelley, this was a blessing: “The social life among our group was carried on in the many comfortable homes of the Negroes [in Ithaca]. Nearly every Friday night, we were welcomed at the home of Mr. and Mrs. Wm. Cannon where we could meet their charming daughter and the other young women of the community. We were allowed to dance and good eats were always served us.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn10",
      "id": "c1_fn10a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("10")])]), _vm._v(" For college students, that was a blessing indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to socializing, the early group members worked to improve their academic opportunities by studying together. The students borrowed one study technique from the members of white fraternities on campus. They banked the tests they took so that black students who took the courses in the future would know how and what to study."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn11",
      "id": "c1_fn11a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon afterward, some leading members of this social/study group suggested that it become a literary society. The idea of a literary society was radical, in the sense that so many Americans were either illiterate or had little or no time for leisure reading. That these African American college men enjoyed such a luxury was telling. Although all the members of the group were amenable to adding literary discourse to their meetings, they could not agree on what to name the society. Some members, such as Jewels Callis and Jones, wanted to use Greek letters, like the white fraternities did. Poindexter, however, demurred, claiming that there were no Greek signifiers that could be used for African Americans. After some debate and research, the leading members of the society came up with the name Alpha Phi Alpha."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn12",
      "id": "c1_fn12a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _vm._v("To support themselves financially, some of the Jewels worked in white fraternity houses, so they were familiar with the idea of a fraternity. Callis and Kelley were employed as waiters at two different fraternity houses, and they made extra money by tutoring some of the fraternity men."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn13",
      "id": "c1_fn13a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("13")])]), _vm._v(" At the turn of the century, attending a college or a university was a feat that some black students had managed to accomplish, but creating a fraternity that paralleled white organizations would have been truly remarkable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Murray, while the group was still meeting as a literary society, he and Jewel Ogle “thought that we (the members of the literary society) ought to try and band ourselves into a fraternal organization the same as the white boys on the hill.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn14",
      "id": "c1_fn14a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("14")])]), _vm._v(" Not surprisingly, some members considered the suggestion of a fraternity fantastic; they did not believe that Africans had enough history on which to base a fraternity. Because of institutional and cultural racial bias, many Americans believed that black people lacked the cultural background and sophistication necessary to create organizations that mirrored the best of white society. In spite of the uncertainty of a few, the idea of a fraternity became a goal for the majority of black men in the literary society.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leading the early charge for a fraternity were all seven Jewels and society members James H. Morton and Morgan T. Phillips."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn15",
      "id": "c1_fn15a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("15")])]), _vm._v(" Those men participated in an initiation ceremony for the society that had been devised by several Jewels (with the help of white fraternity members at whose houses they worked), and the ritual took place at a local Masonic hall in Ithaca. The members of the society had the support of various white fraternities, professors, and black community members who offered moral and financial encouragement. Unfortunately, they did not enjoy the backing of society president Poindexter, but his discouragement actually fueled their desire to push forward with the idea of a fraternal brotherhood. In the weeks leading up to the official decision to become a fraternity, the society members debated vigorously whether to move ahead with the idea."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn16",
      "id": "c1_fn16a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("“Our Dear Fraternal Bond”")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("On Tuesday, December 4, 1906, Poindexter submitted his resignation from the literary society, as did another member. With the main opposition removed, seven members of the literary society voted to create Alpha Phi Alpha Fraternity at Cornell University."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn17",
      "id": "c1_fn17a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("17")])]), _vm._v(" Although black physicians in Philadelphia had created a fraternity in 1904, and college fraternities had existed in the United States for "), _c('a', {
    attrs: {
      "id": "page24"
    }
  }), _vm._v("more than 130 years, no previous fraternity had fashioned itself specifically for the fellowship of black college men. In 1905, Ogle had researched the potential existence of a fraternity at Ohio State University but found no evidence to prove as much. In "), _c('em', [_vm._v("Black Greek 101,")]), _vm._v(" author Walter Kimbrough mentions a fraternity that had a short life in another northern school, but neither it nor any other college organization got beyond the initial stages. In this singular act, Alpha distinguished itself. This black college fraternity quickly initiated its first members and set about the business of refining the experiment. Incidentally, the fraternity treated those first initiates to such fineries as demitasse, ladyfingers, and lamb chops—not a typical meal for the majority of Americans."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn18",
      "id": "c1_fn18a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Believing that other black college men needed the fellowship that the fraternity had to offer, Alpha sought to expand. Although not outright exclusionary, the fraternity was selective about opening its doors to members from other universities. Renowned historian and past general president of the fraternity Charles H. Wesley noted, “It was only natural that the thought of the master builders of this early period should be turned toward other colleges and universities of first rank.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn19",
      "id": "c1_fn19a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("19")])]), _vm._v(" The original members of the fraternity debated just how open Alpha should be to expansion. Kelley and Tandy believed it was their duty to guard the fraternity from members who would harm its ideals. Kelley wrote that Tandy “was anxious that we retain our custom of selecting members in our Chapters so that the organizations would not become packed with undesirables.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn20",
      "id": "c1_fn20a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("20")])]), _vm._v(" The founders eventually agreed that the fraternity should allow “the granting of charters to bodies that meet with their distinct approval.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn21",
      "id": "c1_fn21a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Toward that end, in 1907, Alpha expanded to Howard University. Established in 1867, Howard was described as an “institution of the ‘higher grade for training colored preachers and teachers to help uplift some of the four million recently emancipated slaves and a quarter million Negroes who had been born free.’”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn22",
      "id": "c1_fn22a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("22")])]), _vm._v(" Considered in many circles to be the most elite of black colleges, Howard became the first of the historically black colleges and universities to recognize a Greek-letter fraternity. Thus, Alpha Phi Alpha was the first fraternity for black college men to be established at a historically black and a predominantly white university.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alpha’s expansion during its first twenty years of existence also indicated its desire to reach universities of “Grade A” recognition. As Alpha’s official history explained, some of the new chapters to which the fraternity granted charters were “located at some of the best universities in the country.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn23",
      "id": "c1_fn23a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("23")])]), _vm._v(" By 1926, Alpha had formed chapters at six of the eight Ivy League universities—Cornell, Columbia, Yale, Pennsylvania, Brown, and Harvard. In the two decades after its "), _c('a', {
    attrs: {
      "id": "page25"
    }
  }), _vm._v("founding, Alpha chartered forty-one chapters in twenty-four different states; eleven resided at historically black colleges and universities. In 1912, Alpha established a chapter at the very first historically black university, Lincoln University in Pennsylvania.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fraternity established another first in 1908 when Alpha became the first international fraternity for black college men when it chartered a chapter at the University of Toronto."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn24",
      "id": "c1_fn24a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("24")])]), _vm._v(" Also in that year, the fraternity incorporated in the state of New York, and in 1912, it incorporated in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Early in its history, Alpha set about uplifting the race by establishing its first national program: “Go to High School; Go to College.” As previously indicated, the members of the uplift movement placed immense value on education and service to the race. In creating such a program, Alpha sought to uplift the race through its youth. Although the education of black youth ranked high on the Alpha’s agenda, the fraternity did not overlook the need for African Americans’ participation in politics. Just as members of the Niagara movement attempted to do, Alpha Phi Alpha attempted to register black American voters with its campaign “A Voteless People Is a Hopeless People.” That program illustrated Alpha’s ability to look outside itself for answers to societal problems. The fact that a college fraternity, which is essentially an organization for social interaction, would take service to its racial community so seriously reflected Alpha’s commitment to using social and economic status to improve the race.")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("The Crowned Jewels of Cornell")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The fact that the Jewels could afford to attend Cornell spoke to their intellectual ability and class status in black America. To be sure, the Jewels were the sons of relatively established families. Various members of their families had served in the Civil War, attended college, taught at the college level, were ministers, owned businesses, and more.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("HENRY ARTHUR CALLIS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Henry Arthur Callis’s father attended Hampton Institute, took several courses at Cornell, and eventually became a prominent African Methodist Episcopal pastor. Jewel Callis (1887–1974) was also related to abolitionist Frederick Douglass. He remembered living in a former “station” of the Underground Railroad and discussing it with Douglass and Harriet Tubman."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn25",
      "id": "c1_fn25a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("25")])]), _vm._v(" Growing up "), _c('a', {
    attrs: {
      "id": "page26"
    }
  }), _vm._v("in Binghamton, New York, Callis was a high school standout who won a state scholarship to attend Cornell. He claimed to have decided to attend Cornell when he was six years old."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn26",
      "id": "c1_fn26a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although he was prominent among the founders, Callis preferred not to be addressed as a “Jewel,” as he found the title somewhat pretentious. He was secretary of the social/study group, and with the help of professors on campus and Jewel Jones, he came up with the name Alpha Phi Alpha. Callis and Jones also created Alpha’s ritual. Callis led the movement to incorporate the fraternity in 1908, served as the third president of Alpha’s chapter on the Cornell campus, and assisted in organizing a chapter at the University of Michigan and in Chicago."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn27",
      "id": "c1_fn27a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("27")])]), _vm._v(" Incidentally, he was the only Jewel to ever hold the title of general president of the fraternity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At one point, Callis had to leave Cornell due to his inability to pay tuition. As Roscoe C. Giles, one of the first initiates of the fraternity, remembered, “by his indefatigable determination,” Callis “returned to secure his degree, setting an example for the faint hearted.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn28",
      "id": "c1_fn28a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("28")])]), _vm._v(" Indeed, Callis conquered one of the many threats that faced black students at Cornell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After attaining his degree at Cornell, Callis attended the University of Chicago and in 1922 received a degree from Rush Medical College in Chicago."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn29",
      "id": "c1_fn29a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("29")])]), _vm._v(" He achieved national acclaim as a medical doctor and ardently advocated the training of African American physicians. In one article he explained that “the Negro physician is in a special class and bears a peculiar burden in this country only because of his racial identity.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn30",
      "id": "c1_fn30a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("30")])]), _vm._v(" He argued that the ratio of black doctors to black patients was too low and that colleges, particularly black colleges, should do more to train students in the sciences to prepare them for medical school. He did his best to solve that problem by taking a post as an associate professor at the Howard University Medical School. Throughout his career, Callis worked at the U.S. Veterans Hospital in Tuskegee, Alabama, and maintained a private practice in Chicago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Callis was a member of the National Medical Association (NMA), which had been created in 1895 by seven black doctors because the American Medical Association (AMA) refused to accept black physicians."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn31",
      "id": "c1_fn31a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("31")])]), _vm._v(" When the AMA also refused to recognize the research of black doctors in its medical journal, the NMA created its own journal, and Callis was published frequently in the "), _c('em', [_vm._v("Journal of the National Medical Association.")]), _vm._v(" Thus, Callis was part of two pioneering black organizations at the turn of the century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Callis had a very full life. On January 9, 1909, he eloped with Alice Dunbar, the former wife of Paul Lawrence Dunbar and a political activist in her own "), _c('a', {
    attrs: {
      "id": "page27"
    }
  }), _vm._v("right."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn32",
      "id": "c1_fn32a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("32")])]), _vm._v(" The relationship did not last. Eventually, Callis married Myrna Colson, an educator, social worker, and member of Alpha Kappa Alpha Sorority."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn33",
      "id": "c1_fn33a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("33")])]), _vm._v(" Both Callis and his wife were life members of the Association for the Study of Negro Life and History (ASNLH). In fact, Mrs. Callis conducted a study on black employment in Washington, D.C., with famed historian Lorenzo Greene, and they presented their findings at an ASNLH conference. Another prominent historian (and Alpha member), Rayford Logan, used Callis’s words as the title for a chapter in his seminal work, "), _c('em', [_vm._v("Betrayal of the Negro")]), _vm._v("."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn34",
      "id": "c1_fn34a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("34")])]), _vm._v(" Callis had assessed the progress of race relations at the beginning of the twentieth century as stagnated on a “low, rugged plateau,” and Logan used Callis’s assessment to frame his explanation of the racism faced by African Americans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not surprisingly, Callis nurtured relationships with other black leaders who had a hand in advancing the status of the race. He corresponded with Alpha men such as scholar W. E. B. DuBois and activist and performer Paul Robeson. He also stayed in contact with community leaders and scholars such as Mary Church Terrell and Alain Locke."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn35",
      "id": "c1_fn35a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("35")])]), _vm._v(" Callis’s communications with such influential people provided testimony to his role in shaping twentieth-century black America.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("CHARLES HENRY CHAPMAN")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With great sentimentality, Charles Henry Chapman (1877–1934)"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn36",
      "id": "c1_fn36a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("36")])]), _vm._v(" observed, “There never was a more beautiful episode in my life than the small part I played in the organization of this fraternity in 1906.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn37",
      "id": "c1_fn37a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("37")])]), _vm._v(" Hailing from Cayuga County, New York, Chapman attended high school at Old Howard University Academy. He was older than many of the other Jewels, having enrolled at Cornell in 1900–1901, left school, and then reenrolled in 1902."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn38",
      "id": "c1_fn38a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("38")])]), _vm._v(" According to Callis, Chapman was “the proprietor of a small brickyard (and) of a private dining room for students.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn39",
      "id": "c1_fn39a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("39")])]), _vm._v(" His experience as either the manager or owner of Spencer Brickyard in Spencer, New York,"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn40",
      "id": "c1_fn40a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("40")])]), _vm._v(" may have fueled his desire to move forward with the fraternity idea. While other members of the society (such as Poindexter and George Thompkins) “could accept inter-collegiate association, but not fraternity … the faith of Chapman had been increased by his own success in business.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn41",
      "id": "c1_fn41a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("41")])]), _vm._v(" Chapman helped oversee the first initiation ceremony for the society and spoke at the first initiation ceremony of the fraternity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chapman had a varied educational career. Before attending and graduating from Cornell, he spent some time at Hampton College and, at one point, took courses from Ohio State University. In school, he made his highest marks "), _c('a', {
    attrs: {
      "id": "page28"
    }
  }), _vm._v("in agriculture, farm management, and soil mapping, so it was a logical step for him to become an educator along those lines."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn42",
      "id": "c1_fn42a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("42")])]), _vm._v(" He taught agriculture for a short while at Alabama Agricultural and Mechanical College and Jackson State College and joined the faculty at Florida Agricultural and Mechanical College in 1924."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn43",
      "id": "c1_fn43a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("43")])]), _vm._v(" Incidentally, Chapman won prizes for his dairy herds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chapman was an inspiration to many. In fact, his fraternity brothers claimed that, in 1932, they organized a chapter of Alpha at Florida A&M with his encouragement. Two years later, Chapman died. The "), _c('em', [_vm._v("Baltimore Afro-American")]), _vm._v(" reported that his “Wife Hurried from Cleveland to His Bedside.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn44",
      "id": "c1_fn44a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("44")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("EUGENE KINCKLE JONES")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eugene Kinckle Jones’s father attended what is now Colgate University; his mother graduated from Howard University and taught at Hartshorn Memorial College."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn45",
      "id": "c1_fn45a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("45")])]), _vm._v(" Jewel Jones (1885–1954) attended Wayland Academy in Virginia and later earned a bachelor’s degree from Virginia Union. His first year at Cornell, he took up civil engineering to prove to university officials that he was capable of performing at the high level required to enter Cornell’s graduate school.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jones was a unique Jewel for several reasons. First, he had already received his bachelor’s degree when he came to Cornell in the fall of 1906 to pursue a master’s degree. Second, he was actually one of the first initiates in the literary society. Third, and most importantly for Alpha, Jones was not designated a Jewel until 1952.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Thomas Pawley III, longtime fraternity member and scholar, although fraternity members unofficially addressed the founders as “Jewels” before 1929, it was not until that year that the term became an official designation. From that time through the middle of the century, another brother, James H. Morton, held the esteemed title and was considered the seventh Jewel. Then, at the 1952 national convention in Ohio, Jewels Callis, Kelley, and Murray and fraternity historian Wesley decided that Jones deserved to take Morton’s place as a Jewel."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn46",
      "id": "c1_fn46a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("46")])]), _vm._v(" Years later, Callis wrote a letter to Wesley justifying his position on the matter of designating Jones a Jewel. He explained, “E. K. Jones ranks as a founder because he with Vertner Tandy set up the three other chapters which, under our N.Y. incorporation, required the "), _c('em', [_vm._v("first")]), _vm._v(" general convention.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn47",
      "id": "c1_fn47a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, Jones did a great deal for the fraternity. He was on the committee to draft a constitution and to re-create the ritual of Alpha, and he acted as the second president of the original chapter. As indicated in Callis’s letter, Jones and Tandy established the second chapter of Alpha at Howard University in 1907. "), _c('a', {
    attrs: {
      "id": "page29"
    }
  }), _vm._v("Shortly afterward, Jones set up a chapter at his alma mater, Virginia Union. During his winter travels, he chartered another chapter at the University of Toronto, making him responsible for internationalizing Alpha. In 1911, he chartered the first official alumni chapter in Louisville, Kentucky, where he taught at Louisville High School for a short time."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn48",
      "id": "c1_fn48a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After Cornell, Jones became a leader in the movement to improve life for African Americans. In 1916, he took a post as executive secretary of the National Urban League (NUL), an organization that sought to assist southern black migrants adjust to the industrial North through training and education."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn49",
      "id": "c1_fn49a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("49")])]), _vm._v(" In that capacity, he lobbied the U.S. secretary of labor to appoint an African American to the post of director of Negro economics."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn50",
      "id": "c1_fn50a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("50")])]), _vm._v(" During the Great Depression, Jones served on President Franklin Delano Roosevelt’s “black cabinet,” which advised the administration on matters of race."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn51",
      "id": "c1_fn51a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("51")])]), _vm._v(" Like several of the other founders, Jones was in contact with the shapers of black America. In fact, scholar (and Alpha member) E. Franklin Frazier worked under Jones’s tutelage at the NUL, and Jones corresponded with opera singer Marian Anderson."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn52",
      "id": "c1_fn52a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jones married Blanche Ruby Watson in 1909, and the couple had two children."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn53",
      "id": "c1_fn53a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("53")])]), _vm._v(" For the rest of his life, he took care of his family and other black families. Further, in his capacity as an NUL executive, National Conference of Social Work member, and member of Alpha, Jones did his best to help African Americans take care of themselves. He died two years after receiving the title of Jewel.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("GEORGE BIDDLE KELLEY")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George Biddle Kelley (1884–1962) was the son of a skilled craftsman who had been a fugitive slave and Union soldier during the Civil War."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn54",
      "id": "c1_fn54a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("54")])]), _vm._v(" He was the grandson of one of the most famous African Methodist Episcopal ministers of the nineteenth century. Kelley’s uncle was a graduate of Harvard and had served during the Civil War with Company A of the esteemed Fifty-fourth Regiment of Massachusetts Volunteers, a unit consisting mostly of literate, free black men. Kelley graduated from the Troy Military Academy and took courses at Rensselaer Polytechnic Institute before enrolling at Cornell to study civil engineering."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn55",
      "id": "c1_fn55a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first president of the original Alpha chapter, Kelley made the motion to approve the name Alpha Phi Alpha for the literary society. He worked at the Theta Beta Pi fraternity house, so the idea of a fraternity was at the forefront of his mind."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn56",
      "id": "c1_fn56a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("56")])]), _vm._v(" He also participated heavily in advancing the discussion of literature and was acting chair when the founders made the decision to become a fraternity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _vm._v("Upon graduation from Cornell, Kelley gained employment with the New York State Engineering Department and worked on the Barge Canal. He later spent thirty-two years working for the State Department of Taxation and Finance and assisted with personal tax preparation."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn57",
      "id": "c1_fn57a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("57")])]), _vm._v(" He retired in 1952.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kelley was rare among the founders, in that he frequently attended national conventions and participated in fraternity operations after he left Cornell. Kelley captured the spirit of Alpha with a story he liked to tell, and fraternity historian Skip Mason has done well to document it. As the story went, Kelley had set up a date in Utica, New York, but discovered that his paycheck would be delayed, leaving him unable to pay for the evening out. A desperate Kelley contacted the founding brothers who still attended Cornell and, within a day, he had enough money for his date."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn58",
      "id": "c1_fn58a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("58")])]), _vm._v(" The generosity of the other Jewels represented the meaning of fraternity for him. (By the way, Kelley never indicated how well the date went.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kelley maintained a busy life outside of Alpha. He was a thirty-third-degree Mason, a member of the Liberty Presbyterian Church, and a board member of his local YMCA. Carrying on the fight for the race, Kelley was the vice chairman of the Troy Council against Discrimination."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn59",
      "id": "c1_fn59a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("59")])]), _vm._v(" Finally, he maintained a loving marriage with Harriet Brooks Grossman, whom he wed in 1934. When Kelley died, his widow received telegrams from Governor Nelson Rockefeller, Attorney General Louis Lefkowits, and State Commissioner for Human Rights J. Edward Conway, testifying to Kelley’s service to New York State."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn60",
      "id": "c1_fn60a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("NATHANIEL ALLISON MURRAY")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In many ways, Nathaniel Allison Murray (1884–1959) was born into black high society. Murray’s family lived a relatively privileged life in Washington, D.C. At one time, Murray’s father was one of the richest African Americans in Washington. His grandfather was a free black man and an abolitionist, and one of that grandfather’s grandparents was Scottish royalty. "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn61",
      "id": "c1_fn61a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("61")])]), _vm._v(" Murray also had an uncle who died during John Brown’s raid on Harpers Ferry. His mother graduated from Oberlin College and taught at Howard; she was involved with the National League of Colored Women and the Colored Women’s Club. Murray’s siblings also attended college at Harvard, Cornell, and Oberlin. Like at least one other Jewel, Murray graduated from M Street High School in Washington D.C."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn62",
      "id": "c1_fn62a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Murray was important to Alpha in many different ways. Aside from founding the fraternity, his remembrances and recollections provided a good deal of the material that constitutes Alpha’s written history. More than any other "), _c('a', {
    attrs: {
      "id": "page31"
    }
  }), _vm._v("founder, Murray noted the events of the early years of the fraternity in his speeches, articles, and addresses. He, like Kelley, attended national conventions and continued to offer his opinions on the direction of the brotherhood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Murray reflected: “In the fall of 1905, your humble servant matriculated into Cornell University, Ithaca, New York, as a student in the College of Agriculture.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn63",
      "id": "c1_fn63a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("63")])]), _vm._v(" From the first meetings of the social/study group in his room, Murray was part of the contingent that wanted to create a fraternity. In fact, he seconded the first motion to move in that direction. At the first initiation of the literary society, he played the organ to set the mood. Murray even suggested a $1 initiation fee and seconded the motion that monthly dues be set at 50 cents. Murray never held a position in the national fraternity, but he made all elected positions possible with his work on the original constitution committee."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn64",
      "id": "c1_fn64a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After college, Murray, like Chapman, began a career as an educator. He returned to Washington, D.C., to teach botany at Dunbar High School and later Armstrong Technical High School, where he stayed until the 1940s. Murray also helped charter an alumni chapter in Washington. By the end of his career, he owned several homes from which he rented rooms. Upon retirement, he moved to Los Angeles, where he mentored young Alpha brothers and became involved with the local alumni chapter."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn65",
      "id": "c1_fn65a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Murray valued both family and fraternity. He stayed faithfully married to his wife, Mary, until his death; she died in 1974. The couple had two daughters. Coming from a proud and established family, it was fitting that Murray establish a brotherhood that endured for longer than a century, and several of his cousins and nephews were members. For Murray, the fraternity was his crowning achievement.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("ROBERT HAROLD OGLE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robert Harold Ogle (1886–1936) attended M Street High School, from which many students went on to higher education."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn66",
      "id": "c1_fn66a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("66")])]), _vm._v(" Upon his arrival in Ithaca, Ogle stayed in the home where Alpha as a fraternity was born: 411 East State Street. It was the residence of Archie and Annie Singleton, and they allowed the founders to meet there. The idea of a fraternity took hold of Ogle in 1905, when he saw an article in the "), _c('em', [_vm._v("Chicago Defender")]), _vm._v(" (one of the most widely read black periodicals in the early twentieth century) describing Pi Gamma Omicron, an alleged fraternity at Ohio State University. Although the registrar of the university informed him that no black fraternity existed there, Ogle and the other Jewels were intrigued.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }), _vm._v("As the social/study group transitioned into a literary society, Ogle acted as the organization’s secretary. He made the initial motion to organize into a fraternity."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn67",
      "id": "c1_fn67a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("67")])]), _vm._v(" Soon after the fraternity came to life, he suggested that a chapter be raised at Howard University in his hometown of Washington, D.C. Brothers of Alpha will always remember Ogle, because he proposed that black and old gold be the official colors of the fraternity."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn68",
      "id": "c1_fn68a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("68")])]), _vm._v(" More than that, he chaired the fraternity’s historical commission that oversaw the publication of Alpha’s official history in 1929."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn69",
      "id": "c1_fn69a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time Alpha Phi Alpha became a fraternity, Ogle had already married Helen Moore, the daughter of one of the Ithaca families that welcomed the black students of Cornell into their homes. The couple had two daughters while Ogle continued his studies. Sorrowfully, Ogle’s wife died in 1908. In spite of his deep grief, he dutifully finished his degree, leaving his daughters in the care of his mother-in-law. He and his daughters later moved back to Washington, D.C."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn70",
      "id": "c1_fn70a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There, in the nation’s capital, Ogle established himself. He chartered an alumni chapter of Alpha and entered the field of politics. Under the chairmanship of Senator Francis E. Warren of Wyoming, Ogle held the position of secretary of the Senate Appropriations Committee. Later, he clerked for two municipal court judges, one of whom was a member of Alpha. His service undoubtedly fostered his uncanny knowledge of parliamentary procedure, and the brothers of his alumni chapter marveled at his ability to keep meetings running efficiently."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn71",
      "id": "c1_fn71a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to his reputation as an excellent parliamentarian, according to Ogle’s daughter, the fraternity founder had an even bigger reputation for being one of Washington’s most eligible bachelors. In an interview with author Skip Mason, she explained that her father was extremely handsome and very well dressed, and he eventually remarried. Like Callis, he married an Alpha Kappa Alpha, Marea Scott."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn72",
      "id": "c1_fn72a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("72")])]), _vm._v(" The couple fit in well with black Washington high society and lived happily together."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn73",
      "id": "c1_fn73a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfortunately, Ogle passed away in 1936, becoming the first of the founders to die. He left behind his wife, who never remarried; his daughters (one of whom became an Alpha Kappa Alpha); and thousands of brothers. Ogle’s attention to detail and his desire for a better life led to the creation of a lasting brotherhood.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("VERTNER WOODSON TANDY")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vertner Woodson Tandy (1885–1949) was born in Lexington, Kentucky. His father owned a construction company and was a prominent member of "), _c('a', {
    attrs: {
      "id": "page33"
    }
  }), _vm._v("Lexington’s black society. Tandy studied at Tuskegee under Booker T. Washington for a short time. Like Kelley and Jones, Tandy had attended another institution of higher learning before entering Cornell."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn74",
      "id": "c1_fn74a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tandy had several characteristics that distinguished him from the other founders. First, he was born and reared in Lexington, which was the southernmost birth city and state of all the Jewels. Second, to many members of Alpha, Tandy seemed larger than life—literally. He stood taller than six feet and weighed some 230 pounds. His size, though, was apparently offset by his charming nature. Callis remembered the Kentucky native showing up at campus wearing his ROTC cadet uniform, complete with tightly fitting pants, and a saxophone tucked under his arm. From the beginning, Callis found Tandy to be a “jovial good natured, lovable fellow with a keen sense of humor.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn75",
      "id": "c1_fn75a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Giles, Tandy, “in his college days … was mischievous and full of tricks and fun.” He recalled that roommates Tandy and Jones pulled a prank on their landlady, who was in the habit of bursting into their room unannounced, as if she expected to catch them doing something immoral. This aggravated the two Jewels, and they plotted to put an end to her interruptions. Knowing that the landlady was a devout Christian who abhorred gambling and games, the Jewels hatched a scheme and enlisted the help of several freshmen, who were instructed to enter the room and take off their clothes. Understandably hesitant, the freshmen were convinced to comply, “under the duress of some threatening gestures of … Tandy.” The Jewels then pretended to be in the midst of a very loud and boisterous card game and waited for the landlady to come break it up. When she entered the room without knocking, she was treated to the sight of several naked freshmen."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn76",
      "id": "c1_fn76a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Giles relayed another story about the fun-loving Jewel, who was “not … a paragon of virtue” and was, on occasion, “a devotee to the Shrine of Becchus [sic] and Aphrodite.” This time, Tandy went missing for a week and would not explain his whereabouts when he returned. Although the brothers were worried, they did not query him further. Soon afterward, though, a preacher from out of town came to Giles’s room, inquiring about a “Reverend Vertner Tandy.” When Giles and his roommates explained that no minister lived at their residence, the preacher insisted that Reverend Tandy did live there and then went on to describe him. Giles later conceded that “the F.B.I. could not have given a better description of the distinguished Jewel.” As it turned out, during Tandy’s weeklong absence, he had gone out of town and run out of traveling money. To make his fare back, he had preached a sermon at the minister’s church, where the congregation took up a collection for him. Apparently thinking that he "), _c('a', {
    attrs: {
      "id": "page34"
    }
  }), _vm._v("would never see the man again, Tandy had told the preacher to contact him if he were ever in Ithaca."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn77",
      "id": "c1_fn77a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though not a minister, Tandy had the spirit of Alpha in his heart. Some brothers might remember Tandy’s mischievous antics, but all members of Alpha remember his contribution to the fraternity. For instance, Tandy, a student of architecture, designed the fraternity pin that all Alphas wear. Tandy also acted as the first treasurer of the fraternity, and he, along with Jones, helped charter the second chapter of the fraternity at Howard University and the fourth chapter at the University of Toronto.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tandy’s determination to make life better for black people did not end when he graduated. When the dean of women at Sage College (an affiliate of Cornell) refused to admit black women to the college, Tandy and others led a movement to allow black women to enroll."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn78",
      "id": "c1_fn78a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("78")])]), _vm._v(" Their efforts were successful, and Sage reluctantly admitted black female students. Tandy was a Mason and an Elk, and in 1917, he became the first African American to be commissioned as an officer in the New York National Guard. He quickly moved up the ranks to captain and then major and eventually commanded a segregated unit of the Fifteenth Infantry."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn79",
      "id": "c1_fn79a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aside from being an officer, a member of several fraternal orders, and an activist, Tandy was one of the first black architects registered in the state of New York. In that role, he became a prominent figure in the upper echelons of black society. He designed several buildings in New York City, including St. Phillip’s Protestant Episcopal Church."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn80",
      "id": "c1_fn80a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("80")])]), _vm._v(" He gained membership in the National Negro Business League (NNBL), another organization that sought the progress of black people through work. The NNBL was the brainchild of men such as Booker T. Washington, who desired to uplift the race through business ownership.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Men were not the only ones who took Washington’s and the NNBL’s goals to heart. Madam C. J. Walker became a multimillionaire by patenting her hair care products and inventions. Based in New York City, she employed hundreds of black people, one of whom was Tandy. Biographer Tananarive Due notes that Walker “built her house with money she’d made from Negroes, and many of those Negroes earned their living from other Negroes.” Her opulence, as it turns out, benefited the rest of New York City’s black community. She hired Tandy to design her home, according to Due, to make the point that black people could advance if they united their efforts."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn81",
      "id": "c1_fn81a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Working with Walker certainly benefited Tandy, who expressed as much at a meeting of the NNBL. He stated, “I want to say to you (Walker), through "), _c('a', {
    attrs: {
      "id": "page35"
    }
  }), _vm._v("your unselfish loyalty to your race and through your achievements and successes that a Negro has been successful and has achieved success in architecture.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn82",
      "id": "c1_fn82a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("82")])]), _vm._v(" Walker spared no expense on her home, and this worked well for Tandy. Another biographer of Walker maintained that “Tandy, it must be said, had profited handsomely from the arrangement, building commission fees into nearly every transaction, from the purchase of the organ to the acquisition of the roof tiles.” In the end, the design was a marvel—“a stately building with a bowed red-brick-and-limestone Georgian façade.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn83",
      "id": "c1_fn83a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("83")])]), _vm._v(" Tandy maintained a relationship with Walker even after he completed the construction of her home. In 1919, both Tandy and Jones attended Walker’s funeral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tandy shared his life’s achievements with his wife, Sadie Dorsette, whom he married on June 3, 1912. The two had a son together. He spoke numerous times at national conventions of the fraternity and was affiliated with an alumni chapter. Tandy embodied all the potential of Alpha Phi Alpha.")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("“Onward and Upward toward the Light”")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("At the turn of the twentieth century, for seven young black men at Cornell University to believe that they could create an institution that was the equal of any white institution was certainly audacious in the eyes of many onlookers—both black and white. By establishing Alpha Phi Alpha and eventually incorporating the fraternity, the Jewels sparked a youth movement that led to the establishment of eight other fraternities and sororities. Moreover, the founders of Alpha cemented a precedent of service and excellence that has remained strong for more than a century. The positive acts of those seven Jewels are manifested in the 300 chapters and more than 150,000 fraternity members that exist today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the early 1900s, Alpha faced problems such as isolation, racism, and skepticism. In the early 2000s, the issues have changed somewhat, and Alpha now faces internal problems such as brutality, individualism, and apathy among its members. Time will tell how the fraternity addresses those issues. Externally, Alpha is leading the push to recognize one of its own, Martin Luther King Jr., with a monument in the nation’s capital. In other arenas, chapters of Alpha are battling health issues, such as HIV and premature birth, that are crippling the black community. These local chapters are offering scholarships to low-income students and fostering the leaders of tomorrow with their leadership institutes. Indeed, the issues that Alpha faces in the future will be the same issues that affect "), _c('a', {
    attrs: {
      "id": "page36"
    }
  }), _vm._v("the black community as a whole. Come what may, Alpha Phi Alpha Fraternity Inc. will continue to achieve its aims of “manly deeds, scholarship, and love for all mankind.”")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn1a"
    }
  }, [_vm._v("1.")]), _vm._v(" For excellent discussions of sharecropping and similar practices, see Peter Daniel, "), _c('em', [_vm._v("The Shadow of Slavery: Peonage in the South, 1901–1969")]), _vm._v(" (Urbana: University of Illinois Press, 1990), and David Oshinsky, "), _c('em', [_vm._v("Worse than Slavery: Parchman Farm and the Ordeal of Jim Crow Justice")]), _vm._v(" (New York: Free Press, 1996), 114–22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn2a"
    }
  }, [_vm._v("2.")]), _vm._v(" During the 1940s, illiteracy rates exceeded 25 percent. Bill Jersey and Richard Wormser, "), _c('em', [_vm._v("The Rise and Fall of Jim Crow,")]), _vm._v(" Program Four: Terror and Triumph, 1940–1954, Quest and Video Line Productions, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn3a"
    }
  }, [_vm._v("3.")]), _vm._v(" Booker T. Washington, ed., "), _c('em', [_vm._v("Tuskegee and Its People: Their Ideals and Achievements")]), _vm._v(" (New York: Negro Universities Press, 1905), 1–15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn4a"
    }
  }, [_vm._v("4.")]), _vm._v(" David Levering Lewis, "), _c('em', [_vm._v("WEB Du Bois: Biography of a Race")]), _vm._v(" (New York: Henry Holt, 1994), 79–116.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn5a"
    }
  }, [_vm._v("5.")]), _vm._v(" Kevin Gaines, "), _c('em', [_vm._v("Uplifting the Race: Black Leadership, Politics, and Culture in the Twentieth Century")]), _vm._v(" (Chapel Hill: University of North Carolina Press, 1996), 1, 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn6a"
    }
  }, [_vm._v("6.")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://rmc.library.cornell.edu/alpha/sevenjewels/index.html",
      "target": "_blank"
    }
  }, [_vm._v("http://rmc.library.cornell.edu/alpha/sevenjewels/index.html")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn7a"
    }
  }, [_vm._v("7.")]), _vm._v(" Charles H. Wesley, "), _c('em', [_vm._v("The History of Alpha Phi Alpha: A Development in College Life")]), _vm._v(" (Washington, D.C.: Foundation Publishers, 1929), 18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn8"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn8a"
    }
  }, [_vm._v("8.")]), _vm._v(" Herman “Skip” Mason, "), _c('em', [_vm._v("The Talented Tenth: The Founders and Presidents of Alpha")]), _vm._v(" (Winter Park, Fla.: Four-G Publishers, 1999), 104.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn9"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn9a"
    }
  }, [_vm._v("9.")]), _vm._v(" N. A. Murray, “The Early History and Ideals of the Founders,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" 60, no. 2 (May–June 1974): 13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn10"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn10a"
    }
  }, [_vm._v("10.")]), _vm._v(" George Biddle Kelley, “Reminisces of a Founder,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" (November-December 1939), in John H. Johnson III, ed., "), _c('em', [_vm._v("Centennial Book of Essays and Letters: Excerpts from the Brotherhood of Alpha Phi Alpha Fraternity, Inc.")]), _vm._v(" (Baltimore: Foundation Publishers, 2006), 20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn11"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn11a"
    }
  }, [_vm._v("11.")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn12"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn12a"
    }
  }, [_vm._v("12.")]), _vm._v(" Charles H. Wesley, "), _c('em', [_vm._v("Henry Arthur Callis: Life and Legacy")]), _vm._v(" (Baltimore: Foundation Publishers, 1977), 26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn13"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn13a"
    }
  }, [_vm._v("13.")]), _vm._v(" Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 25; Roscoe C. Giles, “Jewel Henry Arthur Callis … A Drop-out with Indefatigable Determination Returned to Cornell University,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" 60, no. 2 (May–June 1974): 11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn14"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn14a"
    }
  }, [_vm._v("14.")]), _vm._v(" Murray, “Early History and Ideals of the Founders,” 13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn15"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn15a"
    }
  }, [_vm._v("15.")]), _vm._v(" Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 14–16.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn16"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn16a"
    }
  }, [_vm._v("16.")]), _vm._v(" Ibid., 23.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn17"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn17a"
    }
  }, [_vm._v("17.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page37"
    }
  }), _vm._v("“Minutes of the Alpha Phi Alpha Society,” December 4, 1906, in Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 508.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn18"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn18a"
    }
  }, [_vm._v("18.")]), _vm._v(" Ibid., 33; Walter Kimbrough, "), _c('em', [_vm._v("Black Greek 101: The Culture, Customs, and Challenges of Black Fraternities and Sororities")]), _vm._v(" (Madison, N.J.: Fairleigh Dickinson University Press, 2003), 29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn19"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn19a"
    }
  }, [_vm._v("19.")]), _vm._v(" Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 40–41.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn20"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn20a"
    }
  }, [_vm._v("20.")]), _vm._v(" George Biddle Kelley, “Jewel Kelley’s Testimonial on Vertner W. Tandy,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" 36, no. 1 (February 1950): 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn21"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn21a"
    }
  }, [_vm._v("21.")]), _vm._v(" Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 41.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn22"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn22a"
    }
  }, [_vm._v("22.")]), _vm._v(" Rayford Logan, "), _c('em', [_vm._v("Howard University: The First Hundred Years, 1867–1967")]), _vm._v(" (New York: New York University Press, 1969); "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://www.howard.edu/longwalk/!longwa11.htm",
      "target": "_blank"
    }
  }, [_vm._v("http://www.howard.edu/longwalk/!longwa11.htm")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn23"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn23a"
    }
  }, [_vm._v("23.")]), _vm._v(" Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn24"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn24a"
    }
  }, [_vm._v("24.")]), _vm._v(" Ibid., 494–95.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn25"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn25a"
    }
  }, [_vm._v("25.")]), _vm._v(" Henry Arthur Callis, “Founder’s Address,” given at the Fiftieth Anniversary General Convention of Alpha Phi Alpha Fraternity Inc., Buffalo, N.Y., 1956, in Johnson, "), _c('em', [_vm._v("Centennial Book of Essays and Letters,")]), _vm._v(" 47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn26"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn26a"
    }
  }, [_vm._v("26.")]), _vm._v(" Wesley, "), _c('em', [_vm._v("Henry Arthur Callis,")]), _vm._v(" 272, 276; Mason, "), _c('em', [_vm._v("Talented Tenth,")]), _vm._v(" 3–4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn27"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn27a"
    }
  }, [_vm._v("27.")]), _vm._v(" “The Last Jewel Enters the Eternal Diadem: Brother Henry Arthur Callis, M.D.,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" 60, no. 4 (December 1974): 19.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn28"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn28a"
    }
  }, [_vm._v("28.")]), _vm._v(" Giles, “Jewel Henry Arthur Callis,” 11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn29"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn29a"
    }
  }, [_vm._v("29.")]), _vm._v(" "), _c('em', [_vm._v("Who’s Who in Colored America,")]), _vm._v(" 1927 ed., s.v. “Henry Arthur Callis.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn30"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn30a"
    }
  }, [_vm._v("30.")]), _vm._v(" Henry Arthur Callis, M.D., “The Need and Training of Negro Physicians,” "), _c('em', [_vm._v("Journal of Negro Education")]), _vm._v(" 4 (1935): 32–41, in Wesley, "), _c('em', [_vm._v("Henry Arthur Callis,")]), _vm._v(" 227.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn31"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn31a"
    }
  }, [_vm._v("31.")]), _vm._v(" Vernon H. Ross, M.D., “History of the National Medical Association,” "), _c('em', [_vm._v("Journal of the American Society of Anesthesiology")]), _vm._v(" 70, no. 3 (March 2006): 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn32"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn32a"
    }
  }, [_vm._v("32.")]), _vm._v(" Eleanor Alexander, "), _c('em', [_vm._v("Lyrics of Sunshine and Shadow: The Courtship of Paul Lawrence Dunbar and Alice Ruth Moore")]), _vm._v(" (New York: Plume, 2004), 174.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn33"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn33a"
    }
  }, [_vm._v("33.")]), _vm._v(" "), _c('em', [_vm._v("Who’s Who in Colored America,")]), _vm._v(" 1927 ed., s.v. “Myrna Colson Callis”; "), _c('em', [_vm._v("Negro Yearbook,")]), _vm._v(" 1937–1938 ed., s.v. “Lorenzo J. Greene and Myrna Colson Callis.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn34"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn34a"
    }
  }, [_vm._v("34.")]), _vm._v(" Rayford Logan, "), _c('em', [_vm._v("Betrayal of the Negro: From Rutherford B. Hayes to Woodrow Wilson")]), _vm._v(" (New York: Collier Books, 1965), 341.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn35"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn35a"
    }
  }, [_vm._v("35.")]), _vm._v(" Henry Arthur Callis Papers, Moorland-Springarn Research Center, Howard University, Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn36"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn36a"
    }
  }, [_vm._v("36.")]), _vm._v(" Chapman’s Cornell University transcript indicates that he was born in 1877 rather than 1876, which is the conventionally accepted date of his birth. Johnson, "), _c('em', [_vm._v("Centennial Book of Essays and Letters,")]), _vm._v(" 51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn37"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn37a"
    }
  }, [_vm._v("37.")]), _vm._v(" Charles H. Chapman, “A Founder Looks Back,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" 18, no. 1 (February 1932): 7.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn38"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn38a"
    }
  }, [_vm._v("38.")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://rmc.library.cornell.edu/alpha/sevenjewels/sevenjewels_2.html",
      "target": "_blank"
    }
  }, [_vm._v("http://rmc.library.cornell.edu/alpha/sevenjewels/sevenjewels_2.html")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn39"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn39a"
    }
  }, [_vm._v("39.")]), _vm._v(" Henry A. Callis, “Founders’ Address,” Alpha Phi Alpha General Convention, 1950, in Johnson, "), _c('em', [_vm._v("Centennial Book of Essays and Letters,")]), _vm._v(" 47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn40"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn40a"
    }
  }, [_vm._v("40.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page38"
    }
  }), _vm._v("Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 536.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn41"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn41a"
    }
  }, [_vm._v("41.")]), _vm._v(" Callis, “Founders’ Address.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn42"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn42a"
    }
  }, [_vm._v("42.")]), _vm._v(" Cornell University transcript of Charles H. Chapman, in Johnson, "), _c('em', [_vm._v("Centennial Book of Essays and Letters,")]), _vm._v(" 51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn43"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn43a"
    }
  }, [_vm._v("43.")]), _vm._v(" “Chapman, Alpha Founder Dies at 68,” "), _c('em', [_vm._v("Baltimore Afro-American,")]), _vm._v(" November 24, 1934, 22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn44"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn44a"
    }
  }, [_vm._v("44.")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn45"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn45a"
    }
  }, [_vm._v("45.")]), _vm._v(" Mason, "), _c('em', [_vm._v("Talented Tenth,")]), _vm._v(" 51–52.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn46"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn46a"
    }
  }, [_vm._v("46.")]), _vm._v(" Thomas D. Pawley III, “The Selection of the Seventh Jewel,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" (spring 1994): 13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn47"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn47a"
    }
  }, [_vm._v("47.")]), _vm._v(" Henry Arthur Callis to Charles Henry Wesley, May 23, 1965, in Wesley, "), _c('em', [_vm._v("Henry Arthur Callis,")]), _vm._v(" 26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn48"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn48a"
    }
  }, [_vm._v("48.")]), _vm._v(" Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 41–45, 71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn49"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn49a"
    }
  }, [_vm._v("49.")]), _vm._v(" Felix L. Armfield, “Jewel Eugene Kinckle Jones & the Development of Early African-American Social Work,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" 84, no. 1 (spring 1999): 23.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn50"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn50a"
    }
  }, [_vm._v("50.")]), _vm._v(" "), _c('em', [_vm._v("Who’s Who in Colored America,")]), _vm._v(" 1927 ed., s.v. “Eugene Kinckle Jones.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn51"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn51a"
    }
  }, [_vm._v("51.")]), _vm._v(" Felix L. Armfield, “Eugene Kinckle Jones and the Rise of Professional Black Social Workers, 1910–1940” (PhD diss., Michigan State University, 1998), 22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn52"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn52a"
    }
  }, [_vm._v("52.")]), _vm._v(" rmc.library.cornell.edu/alpha/sevenjewels/sevenjewels_3.html.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn53"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn53a"
    }
  }, [_vm._v("53.")]), _vm._v(" Armfield, “Jones and the Rise of Professional Black Social Workers,” 22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn54"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn54a"
    }
  }, [_vm._v("54.")]), _vm._v(" “Death Claims the Body of Brother Jewel George Biddle Kelley … But His Spirit Marches On,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" (October 1962): 2, in Johnson, "), _c('em', [_vm._v("Centennial Book of Essays and Letters,")]), _vm._v(" 54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn55"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn55a"
    }
  }, [_vm._v("55.")]), _vm._v(" Emilio Louis, "), _c('em', [_vm._v("A Brave Black Regiment: Massachusetts Volunteer Infantry, 1863–1865,")]), _vm._v(" 3d ed. (Salem, Mass.: Ayer Company Publishers, 1990), 339.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn56"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn56a"
    }
  }, [_vm._v("56.")]), _vm._v(" Wesley, "), _c('em', [_vm._v("Henry Arthur Callis,")]), _vm._v(" 24.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn57"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn57a"
    }
  }, [_vm._v("57.")]), _vm._v(" “Death Claims the Body of Brother Kelley,” 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn58"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn58a"
    }
  }, [_vm._v("58.")]), _vm._v(" Mason, "), _c('em', [_vm._v("The Talented Tenth,")]), _vm._v(" 82–84.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn59"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn59a"
    }
  }, [_vm._v("59.")]), _vm._v(" “Death Claims the Body of Brother Kelley,” 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn60"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn60a"
    }
  }, [_vm._v("60.")]), _vm._v(" “Death Claims the Body of Brother Kelley,” in Johnson, "), _c('em', [_vm._v("Centennial Book of Essays and Letters,")]), _vm._v(" 53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn61"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn61a"
    }
  }, [_vm._v("61.")]), _vm._v(" Mason, "), _c('em', [_vm._v("Talented Tenth,")]), _vm._v(" 95–99.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn62"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn62a"
    }
  }, [_vm._v("62.")]), _vm._v(" Leroy Graham, "), _c('em', [_vm._v("Baltimore: The Nineteenth Century Black Capital")]), _vm._v(" (Lanham, Md.: University Press of America, 1982), 269–72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn63"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn63a"
    }
  }, [_vm._v("63.")]), _vm._v(" Murray, “Early History and Ideals of the Founders,” 13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn64"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn64a"
    }
  }, [_vm._v("64.")]), _vm._v(" “Minutes of the Social Study Club,” “Minutes of Alpha Phi Alpha Society,” and “Minutes of Alpha Phi Alpha,” June 2, 1906, through April 3, 1912, in Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 505–39.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn65"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn65a"
    }
  }, [_vm._v("65.")]), _vm._v(" Mason, "), _c('em', [_vm._v("Talented Tenth,")]), _vm._v(" 102–3, 119–23.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn66"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn66a"
    }
  }, [_vm._v("66.")]), _vm._v(" Callis, “Founders’ Address,” 47; Wesley, "), _c('em', [_vm._v("Henry Arthur Callis,")]), _vm._v(" 276.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn67"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn67a"
    }
  }, [_vm._v("67.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page39"
    }
  }), _vm._v("Nathaniel A. Murray, “The Aims of Our Dear Fraternity …,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" 45, no. 1 (February 1960): 28, 33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn68"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn68a"
    }
  }, [_vm._v("68.")]), _vm._v(" “Minutes of the Social Study Club,” October 23, 1906, in Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 506.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn69"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn69a"
    }
  }, [_vm._v("69.")]), _vm._v(" Wesley, "), _c('em', [_vm._v("History of Alpha Phi Alpha,")]), _vm._v(" 169; Mason, "), _c('em', [_vm._v("Talented Tenth,")]), _vm._v(" 134.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn70"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn70a"
    }
  }, [_vm._v("70.")]), _vm._v(" Mason, "), _c('em', [_vm._v("Talented Tenth,")]), _vm._v(" 131.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn71"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn71a"
    }
  }, [_vm._v("71.")]), _vm._v(" Emory Smith, “Alpha Phi Alpha His First Love,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" 23, no. 3 (February 1937): 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn72"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn72a"
    }
  }, [_vm._v("72.")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn73"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn73a"
    }
  }, [_vm._v("73.")]), _vm._v(" Mason, "), _c('em', [_vm._v("Talented Tenth,")]), _vm._v(" 133.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn74"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn74a"
    }
  }, [_vm._v("74.")]), _vm._v(" Wesley, "), _c('em', [_vm._v("Henry Arthur Callis,")]), _vm._v(" 20; Mason, "), _c('em', [_vm._v("Talented Tenth,")]), _vm._v(" 134.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn75"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn75a"
    }
  }, [_vm._v("75.")]), _vm._v(" Henry Arthur Callis, “Jewel Callis’ Testimonial to Vertner W. Tandy, Founder,” "), _c('em', [_vm._v("Sphinx")]), _vm._v(" 36, no. 1 (February 1950): 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn76"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn76a"
    }
  }, [_vm._v("76.")]), _vm._v(" Giles, “Jewel Henry Arthur Callis,” 15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn77"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn77a"
    }
  }, [_vm._v("77.")]), _vm._v(" Ibid, 11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn78"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn78a"
    }
  }, [_vm._v("78.")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn79"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn79a"
    }
  }, [_vm._v("79.")]), _vm._v(" "), _c('em', [_vm._v("Who’s Who in Colored America,")]), _vm._v(" 1927 ed., s.v. “Vertner W. Tandy.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn80"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn80a"
    }
  }, [_vm._v("80.")]), _vm._v(" Callis, “Callis’ Testimonial to Tandy,” 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn81"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn81a"
    }
  }, [_vm._v("81.")]), _vm._v(" Tananarive Due, "), _c('em', [_vm._v("The Black Rose: The Dramatic Story of Madam C. J. Walker, America’s First Black Female Millionaire")]), _vm._v(" (New York: Ballantine Books, 2001), 345.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn82"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn82a"
    }
  }, [_vm._v("82.")]), _vm._v(" A’Lelia Perry Bundles, "), _c('em', [_vm._v("On Her Own Ground: The Life and Times of Madame C. J. Walker")]), _vm._v(" (New York: Scribner Books, 2002), 236–37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c1_fn83"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c1_fn83a"
    }
  }, [_vm._v("83.")]), _vm._v(" Ibid., 171.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b39c7d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780813172958_epub_c01_r1.vue
// module id = 87
// module chunks = 0